import PropTypes from "prop-types";

// @mui material components
import { Grid } from "@mui/material";
import { Controller } from "react-hook-form";

// Material Dashboard 2 PRO React components
import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import MDButton from "../../../../../components/MDButton";

import FormField from "../FormField";

function AuthorInfo({ control, errors }) {

  return (
    <MDBox>
      <MDTypography variant="h5" mb={3}>
        Sobre el autor
      </MDTypography>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Nombre"
                error={!!errors.name}
                helperText={errors.name?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="lastName"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Apellidos"
                error={!!errors.lastName}
                helperText={errors.lastName?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="bio"
            control={control}
            render={({ field }) => (
              <FormField
                {...field}
                label="Biografía"
                error={!!errors.bio}
                helperText={errors.bio?.message}
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={12}>
          <Controller
            name="avatar"
            control={control}
            render={({ field }) => (
              <MDBox mb={2}>
                <MDTypography variant="button" fontWeight="regular" color="text">
                  Avatar
                </MDTypography>
                {field.value && (
                  <MDBox mt={2} mb={2}>
                    <img src={field.value} alt="Avatar" style={{ width: "100%", maxHeight: "200px", objectFit: "contain", borderRadius: "8px" }} />
                  </MDBox>
                )}
                <input
                  id="logo-upload-input"
                  style={{ display: "none" }}
                  accept="image/*"
                  type="file"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      const reader = new FileReader();
                      reader.onloadend = () => {
                        field.onChange(reader.result);
                      };
                      reader.readAsDataURL(file);
                    }
                  }}
                />
                <MDButton
                  variant="outlined"
                  color="info"
                  fullWidth
                  onClick={() => document.getElementById("logo-upload-input").click()}
                >
                  Subir Avatar
                </MDButton>
                {errors.avatar && (
                  <MDTypography variant="caption" color="error">
                    {errors.avatar.message}
                  </MDTypography>
                )}
              </MDBox>
            )}
          />
        </Grid>

      </Grid>
    </MDBox>
  );
}

AuthorInfo.propTypes = {
  control: PropTypes.isRequired,
  errors: PropTypes.isRequired,
};

export default AuthorInfo;
